import { DotsHorizontalIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import { MenuRoot } from "./MenuRoot";
import type { MenuMoreProps } from "./Menu.types";

/**
 * The three-dots "More actions" menu for row and card actions: an icon-only
 * `sm` secondary Button whose popup aligns to its end edge.
 */
export const MenuMore = ({
    "aria-label": ariaLabel = "More actions",
    variant = "secondary",
    size = "sm",
    className,
    tabIndex,
    triggerAttributes,
    align = "end",
    ...rootProps
}: MenuMoreProps) => (
    <MenuRoot
        {...rootProps}
        align={align}
        trigger={
            <Button
                {...triggerAttributes}
                type="button"
                iconOnly
                variant={variant}
                size={size}
                aria-label={ariaLabel}
                className={className}
                tabIndex={tabIndex}
            >
                <DotsHorizontalIcon />
            </Button>
        }
    />
);
